/**
 * 售后相关页面的路由
 */
const afterSaleRouter = [
  {
    path: `/after-sale`,
    component: () => import(`@/views/after-sale/index`),
    name: `afterSale`,
    meta: { title: '售后列表', auth: false },
  },
  {
    path: `/after-sale/apply`,
    component: () => import(`@/views/after-sale/apply`),
    name: `SelectType`,
    meta: { title: '选择售后类型', auth: false },
  },
  {
    path: `/after-sale/detail`,
    component: () => import(`@/views/after-sale/detail`),
    name: `Detail`,
    meta: { title: '退款详情', auth: false },
  },
  {
    path: `/after-sale/return-form`,
    component: () => import(`@/views/after-sale/returnForm`),
    name: `ReturnForm`,
    meta: { title: '填写退货单', auth: false },
  },
];

export default afterSaleRouter;
